/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
var rpc_admin_image_pb = require('../../rpc/admin/image_pb.js');
goog.object.extend(proto, rpc_admin_image_pb);
goog.exportSymbol('proto.admin.GetZandersProductRequest', null, global);
goog.exportSymbol('proto.admin.ZandersProduct', null, global);
goog.exportSymbol('proto.admin.ZandersProduct.AttributeValuePair', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.ZandersProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.ZandersProduct.repeatedFields_, null);
};
goog.inherits(proto.admin.ZandersProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.ZandersProduct.displayName = 'proto.admin.ZandersProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.ZandersProduct.AttributeValuePair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.ZandersProduct.AttributeValuePair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.ZandersProduct.AttributeValuePair.displayName = 'proto.admin.ZandersProduct.AttributeValuePair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GetZandersProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.GetZandersProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GetZandersProductRequest.displayName = 'proto.admin.GetZandersProductRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.ZandersProduct.repeatedFields_ = [26,29,39];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.ZandersProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.ZandersProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.ZandersProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ZandersProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemno: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    upc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mpn: jspb.Message.getFieldWithDefault(msg, 4, ""),
    msrp: +jspb.Message.getFieldWithDefault(msg, 5, 0.0),
    price: +jspb.Message.getFieldWithDefault(msg, 6, 0.0),
    qtyavail: jspb.Message.getFieldWithDefault(msg, 7, 0),
    zancat: jspb.Message.getFieldWithDefault(msg, 8, ""),
    categoryname: jspb.Message.getFieldWithDefault(msg, 9, ""),
    category: jspb.Message.getFieldWithDefault(msg, 10, ""),
    webcategory2: jspb.Message.getFieldWithDefault(msg, 11, ""),
    webcategory3: jspb.Message.getFieldWithDefault(msg, 12, ""),
    webcategory4: jspb.Message.getFieldWithDefault(msg, 13, ""),
    webcategory5: jspb.Message.getFieldWithDefault(msg, 14, ""),
    webcategory6: jspb.Message.getFieldWithDefault(msg, 15, ""),
    saleStart: jspb.Message.getFieldWithDefault(msg, 16, ""),
    saleEnd: jspb.Message.getFieldWithDefault(msg, 17, ""),
    salePrice: +jspb.Message.getFieldWithDefault(msg, 18, 0.0),
    productType: jspb.Message.getFieldWithDefault(msg, 19, ""),
    weight: +jspb.Message.getFieldWithDefault(msg, 20, 0.0),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 21, ""),
    serialized: jspb.Message.getFieldWithDefault(msg, 22, false),
    boFlag: jspb.Message.getFieldWithDefault(msg, 23, false),
    mapprice: +jspb.Message.getFieldWithDefault(msg, 24, 0.0),
    showPriceInCart: jspb.Message.getFieldWithDefault(msg, 25, false),
    attributesList: jspb.Message.toObjectList(msg.getAttributesList(),
    proto.admin.ZandersProduct.AttributeValuePair.toObject, includeInstance),
    textDescription: jspb.Message.getFieldWithDefault(msg, 27, ""),
    htmlDescription: jspb.Message.getFieldWithDefault(msg, 28, ""),
    imageLinksList: jspb.Message.getRepeatedField(msg, 29),
    caCompliant: jspb.Message.getFieldWithDefault(msg, 30, false),
    price1: +jspb.Message.getFieldWithDefault(msg, 31, 0.0),
    price2: +jspb.Message.getFieldWithDefault(msg, 32, 0.0),
    price3: +jspb.Message.getFieldWithDefault(msg, 33, 0.0),
    qty1: jspb.Message.getFieldWithDefault(msg, 34, 0),
    qty2: jspb.Message.getFieldWithDefault(msg, 35, 0),
    qty3: jspb.Message.getFieldWithDefault(msg, 36, 0),
    action: jspb.Message.getFieldWithDefault(msg, 37, ""),
    caliber: jspb.Message.getFieldWithDefault(msg, 38, ""),
    imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    rpc_admin_image_pb.Image.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.ZandersProduct}
 */
proto.admin.ZandersProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.ZandersProduct;
  return proto.admin.ZandersProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.ZandersProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.ZandersProduct}
 */
proto.admin.ZandersProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemno(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMpn(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMsrp(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQtyavail(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setZancat(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryname(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebcategory2(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebcategory3(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebcategory4(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebcategory5(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebcategory6(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleStart(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleEnd(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSalePrice(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductType(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeight(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturer(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSerialized(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoFlag(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMapprice(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowPriceInCart(value);
      break;
    case 26:
      var value = new proto.admin.ZandersProduct.AttributeValuePair;
      reader.readMessage(value,proto.admin.ZandersProduct.AttributeValuePair.deserializeBinaryFromReader);
      msg.addAttributes(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextDescription(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlDescription(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.addImageLinks(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCaCompliant(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice1(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice2(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice3(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQty1(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQty2(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQty3(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaliber(value);
      break;
    case 39:
      var value = new rpc_admin_image_pb.Image;
      reader.readMessage(value,rpc_admin_image_pb.Image.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.ZandersProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.ZandersProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.ZandersProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ZandersProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemno();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUpc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMpn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMsrp();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getQtyavail();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getZancat();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCategoryname();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getWebcategory2();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getWebcategory3();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getWebcategory4();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getWebcategory5();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getWebcategory6();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSaleStart();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSaleEnd();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSalePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getProductType();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getManufacturer();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getSerialized();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getBoFlag();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getMapprice();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getShowPriceInCart();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      26,
      f,
      proto.admin.ZandersProduct.AttributeValuePair.serializeBinaryToWriter
    );
  }
  f = message.getTextDescription();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getHtmlDescription();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getImageLinksList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      29,
      f
    );
  }
  f = message.getCaCompliant();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getPrice1();
  if (f !== 0.0) {
    writer.writeDouble(
      31,
      f
    );
  }
  f = message.getPrice2();
  if (f !== 0.0) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = message.getPrice3();
  if (f !== 0.0) {
    writer.writeDouble(
      33,
      f
    );
  }
  f = message.getQty1();
  if (f !== 0) {
    writer.writeInt32(
      34,
      f
    );
  }
  f = message.getQty2();
  if (f !== 0) {
    writer.writeInt32(
      35,
      f
    );
  }
  f = message.getQty3();
  if (f !== 0) {
    writer.writeInt32(
      36,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getCaliber();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      39,
      f,
      rpc_admin_image_pb.Image.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.ZandersProduct.AttributeValuePair.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.ZandersProduct.AttributeValuePair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.ZandersProduct.AttributeValuePair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ZandersProduct.AttributeValuePair.toObject = function(includeInstance, msg) {
  var f, obj = {
    attribute: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.ZandersProduct.AttributeValuePair}
 */
proto.admin.ZandersProduct.AttributeValuePair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.ZandersProduct.AttributeValuePair;
  return proto.admin.ZandersProduct.AttributeValuePair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.ZandersProduct.AttributeValuePair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.ZandersProduct.AttributeValuePair}
 */
proto.admin.ZandersProduct.AttributeValuePair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttribute(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.ZandersProduct.AttributeValuePair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.ZandersProduct.AttributeValuePair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.ZandersProduct.AttributeValuePair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ZandersProduct.AttributeValuePair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttribute();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string attribute = 1;
 * @return {string}
 */
proto.admin.ZandersProduct.AttributeValuePair.prototype.getAttribute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.AttributeValuePair.prototype.setAttribute = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.admin.ZandersProduct.AttributeValuePair.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.AttributeValuePair.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string itemno = 1;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getItemno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setItemno = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string upc = 3;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getUpc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setUpc = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mpn = 4;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getMpn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setMpn = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double msrp = 5;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getMsrp = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 5, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setMsrp = function(value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double price = 6;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getPrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 6, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setPrice = function(value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 qtyavail = 7;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getQtyavail = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setQtyavail = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string zancat = 8;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getZancat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setZancat = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string categoryname = 9;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getCategoryname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setCategoryname = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string category = 10;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setCategory = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string webcategory2 = 11;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getWebcategory2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setWebcategory2 = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string webcategory3 = 12;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getWebcategory3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setWebcategory3 = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string webcategory4 = 13;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getWebcategory4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setWebcategory4 = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string webcategory5 = 14;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getWebcategory5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setWebcategory5 = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string webcategory6 = 15;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getWebcategory6 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setWebcategory6 = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string sale_start = 16;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getSaleStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setSaleStart = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string sale_end = 17;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getSaleEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setSaleEnd = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional double sale_price = 18;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getSalePrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 18, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setSalePrice = function(value) {
  jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional string product_type = 19;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getProductType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setProductType = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional double weight = 20;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getWeight = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 20, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setWeight = function(value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional string manufacturer = 21;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getManufacturer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setManufacturer = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional bool serialized = 22;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.ZandersProduct.prototype.getSerialized = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 22, false));
};


/** @param {boolean} value */
proto.admin.ZandersProduct.prototype.setSerialized = function(value) {
  jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool bo_flag = 23;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.ZandersProduct.prototype.getBoFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 23, false));
};


/** @param {boolean} value */
proto.admin.ZandersProduct.prototype.setBoFlag = function(value) {
  jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional double mapprice = 24;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getMapprice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 24, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setMapprice = function(value) {
  jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional bool show_price_in_cart = 25;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.ZandersProduct.prototype.getShowPriceInCart = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 25, false));
};


/** @param {boolean} value */
proto.admin.ZandersProduct.prototype.setShowPriceInCart = function(value) {
  jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * repeated AttributeValuePair attributes = 26;
 * @return {!Array<!proto.admin.ZandersProduct.AttributeValuePair>}
 */
proto.admin.ZandersProduct.prototype.getAttributesList = function() {
  return /** @type{!Array<!proto.admin.ZandersProduct.AttributeValuePair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.ZandersProduct.AttributeValuePair, 26));
};


/** @param {!Array<!proto.admin.ZandersProduct.AttributeValuePair>} value */
proto.admin.ZandersProduct.prototype.setAttributesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 26, value);
};


/**
 * @param {!proto.admin.ZandersProduct.AttributeValuePair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.ZandersProduct.AttributeValuePair}
 */
proto.admin.ZandersProduct.prototype.addAttributes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.admin.ZandersProduct.AttributeValuePair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.ZandersProduct.prototype.clearAttributesList = function() {
  this.setAttributesList([]);
};


/**
 * optional string text_description = 27;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getTextDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setTextDescription = function(value) {
  jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string html_description = 28;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getHtmlDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setHtmlDescription = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * repeated string image_links = 29;
 * @return {!Array<string>}
 */
proto.admin.ZandersProduct.prototype.getImageLinksList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 29));
};


/** @param {!Array<string>} value */
proto.admin.ZandersProduct.prototype.setImageLinksList = function(value) {
  jspb.Message.setField(this, 29, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.ZandersProduct.prototype.addImageLinks = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 29, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.ZandersProduct.prototype.clearImageLinksList = function() {
  this.setImageLinksList([]);
};


/**
 * optional bool ca_compliant = 30;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.ZandersProduct.prototype.getCaCompliant = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 30, false));
};


/** @param {boolean} value */
proto.admin.ZandersProduct.prototype.setCaCompliant = function(value) {
  jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional double price1 = 31;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getPrice1 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 31, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setPrice1 = function(value) {
  jspb.Message.setProto3FloatField(this, 31, value);
};


/**
 * optional double price2 = 32;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getPrice2 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 32, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setPrice2 = function(value) {
  jspb.Message.setProto3FloatField(this, 32, value);
};


/**
 * optional double price3 = 33;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getPrice3 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 33, 0.0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setPrice3 = function(value) {
  jspb.Message.setProto3FloatField(this, 33, value);
};


/**
 * optional int32 qty1 = 34;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getQty1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setQty1 = function(value) {
  jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional int32 qty2 = 35;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getQty2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setQty2 = function(value) {
  jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional int32 qty3 = 36;
 * @return {number}
 */
proto.admin.ZandersProduct.prototype.getQty3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/** @param {number} value */
proto.admin.ZandersProduct.prototype.setQty3 = function(value) {
  jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional string action = 37;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setAction = function(value) {
  jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string caliber = 38;
 * @return {string}
 */
proto.admin.ZandersProduct.prototype.getCaliber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/** @param {string} value */
proto.admin.ZandersProduct.prototype.setCaliber = function(value) {
  jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * repeated Image images = 39;
 * @return {!Array<!proto.admin.Image>}
 */
proto.admin.ZandersProduct.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.admin.Image>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_image_pb.Image, 39));
};


/** @param {!Array<!proto.admin.Image>} value */
proto.admin.ZandersProduct.prototype.setImagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 39, value);
};


/**
 * @param {!proto.admin.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Image}
 */
proto.admin.ZandersProduct.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 39, opt_value, proto.admin.Image, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.ZandersProduct.prototype.clearImagesList = function() {
  this.setImagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GetZandersProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GetZandersProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GetZandersProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetZandersProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemno: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GetZandersProductRequest}
 */
proto.admin.GetZandersProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GetZandersProductRequest;
  return proto.admin.GetZandersProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GetZandersProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GetZandersProductRequest}
 */
proto.admin.GetZandersProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GetZandersProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GetZandersProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GetZandersProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetZandersProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemno();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string itemno = 1;
 * @return {string}
 */
proto.admin.GetZandersProductRequest.prototype.getItemno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.GetZandersProductRequest.prototype.setItemno = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.admin);
